export default __webpack_public_path__ + "static/media/instagram_outlined.2d581020.svg";